import firebase from 'firebase';
import { AppDispatch } from '../../store';
import { COLLECTIONS } from '../../constants/data';
import { serializeWalletSnap } from './wallet.service';
import { resetWallet, walletListenerError, walletUpdated } from './wallet.slice';

let unsubscribeWallet: firebase.Unsubscribe | null = null;
let activeWalletKey: string | null = null;

export const syncWalletListener = (
  uid: string | null,
  restaurantId: string | null,
  dispatch: AppDispatch
) => {
  const key = uid && restaurantId ? `${uid}::${restaurantId}` : null;
  if (key === activeWalletKey) return;

  if (unsubscribeWallet) { unsubscribeWallet(); unsubscribeWallet = null; }

  activeWalletKey = key;

  if (!key || !uid || !restaurantId) {
    dispatch(resetWallet());
    return;
  }

  unsubscribeWallet = firebase.firestore()
    .collection(COLLECTIONS.users).doc(uid)
    .collection(COLLECTIONS.wallets).doc(restaurantId)
    .onSnapshot(
      (snapshot) => {
        dispatch(walletUpdated(snapshot.exists ? serializeWalletSnap(snapshot) : null));
      },
      (error) => {
        dispatch(walletListenerError(error.message));
        activeWalletKey = null;
        unsubscribeWallet = null;
      }
    );
};